module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/inmuebles24.c3e18f6a.svg";